<template>
  <div>
    <v-overlay :value="loading" :absolute="true" v-if="$route.name !== 'reportPrint'">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>
    <InvoicesReportTemplate v-if="$route.name === 'reportPrint'"
                            :entries="invoices"
                            :totalsCounts="totalsCounts"
                            :from="from"
                            :to="to"
                            :key="'reportTemplateKey' + invoices.length"
                            :companyId="companyId"
                            :simplified="$route.params.isDOT"
    />
    <v-card v-else>
      <v-card-title :style="{ backgroundColor: $root.currentTheme.background }">
        {{$t('Reports.Invoices')}}
      </v-card-title>
      <InvoicesTotals :totalsCounts="totalsCounts" v-if="totalsCounts"/>
      <!--<v-layout>
        <v-flex xs12>
          <v-card class="ma-2">
            <ReportsGroupsList :type="$route.params.type" :userId="0" :totalsCountsNames="totalsCountsNames" :totalsCounts="totalsCounts" :key="reportsGroupsListKey"></ReportsGroupsList>
          </v-card>
        </v-flex>
      </v-layout>-->

      <!--<v-layout wrap>
        <v-flex xs12 md6>
          <v-simple-table dense class="mb-5">
            <template v-slot:default>
              <tbody>
              <tr>
                <th class="text-left" colspan="2">
                  <h1>Totals</h1>
                </th>
              </tr>
              <tr>
                <td class="text-left">Invoices Count</td>
                <td class="text-left">{{totalsCounts.totalCount.toLocaleString()}}</td>
              </tr>
              <tr>
                <td class="text-left">Invoices Paid</td>
                <td class="text-left">{{totalsCounts.totalPaid.toLocaleString()}}</td>
              </tr>
              <tr>
                <td class="text-left">Amount</td>
                <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalAmount).toFixed(2).toLocaleString()}}</td>
              </tr>
              <tr>
                <td class="text-left">Received</td>
                <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalReceived).toFixed(2).toLocaleString()}}</td>
              </tr>
              <tr>
                <td class="text-left">Expected</td>
                <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalExpected).toFixed(2).toLocaleString()}}</td>
              </tr>
              <tr>
                <td class="text-left">Factoring Fees</td>
                <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalFactoting).toFixed(2).toLocaleString()}}</td>
              </tr>
              <tr>
                <td class="text-left">Expected Factoring Fees</td>
                <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalExpectedFactoting).toFixed(2).toLocaleString()}}</td>
              </tr>
              <tr>
                <td class="text-left">Received Adv.</td>
                <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalReceivedAdv).toFixed(2).toLocaleString()}}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-flex>
      </v-layout>-->

      <v-divider/>
      <ReportActions
        :key="reportsGroupsListKey"
        :userId="0"
        :from="from"
        :to="to"
        :paramsType="$route.params.type"
        :selectedItems="selectedItems"
        :isSelectedHaveNotPayed="isSelectedHaveNotPayed"
        :isSelectedHavePayed="isSelectedHavePayed"
        @create-report-group="createReport"
        @mark-selected-as-paid="markSelectedAsPaid"
        @mark-selected-as-not-paid="markSelectedAsNotPaid"
        @mark-selected-as-payed-and-create-report-group="markSelectedAsPayedAndCreateReportGroup"
        @show-saved-reports="$root.onShowReportsModal"
      />
      <v-layout v-if="$root.isFullFinancialDataAllowedToView" wrap>
        <!-- <v-flex shrink class="text-right text-no-wrap">
          <v-select
            class="ma-1"
            outlined dense
            :items="['All','New','Ready','Verified','Pending','Paid','Underpaid','Not Paid','Overdue']"
            v-model="statusFilter"
            @change="statusFilterChanged"
            :label="$t('Invoices.StatusFilter')"
          />
        </v-flex> -->
        <v-flex shrink>
          <FiltersPanel
            ref="filtersPanel"
            prefix="invoicesReport"
            outlined
            :isExpansionPanel="$root.isMobile"
            :loading="loading"
            :items="[statusFilter, dispatcherFilter, driverFilter, truckFilter, brokerFilter]"
            :key="statusFilter.name + statusFilter.list.length + dispatcherFilter.name + dispatcherFilter.list.length + driverFilter.name + driverFilter.list.length + truckFilter.name + truckFilter.list.length"
            @filterBrokerKeyUp="filterBrokerSearch"
            @change="onFilterChanged"/>
        </v-flex>
        <v-flex>
          <v-text-field
              class="mt-1"
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Search"
              single-line
              outlined dense
              hide-details
          />
        </v-flex>
        <v-flex shrink v-if="$root.isMobile">
            <v-btn class="mt-1 ml-1"
                    @click="$refs.filtersPanel.showFiltersDrawer()">
                    <v-icon>mdi-filter</v-icon>
            </v-btn>
          </v-flex>
        <!--<v-flex shrink shrink>
          <v-btn class="ma-1" :disabled="selectedItems.length === 0" @click="createReportGroup(0, lastReportsGroupNumber + 1, $route.params.type, from, to)"><v-icon left>mdi-clipboard-check-outline</v-icon> {{$t('Reports.CreateReportsGroup')}}</v-btn>
        </v-flex>-->
      </v-layout>

      <v-list v-if="$root.isMobile">
        <v-list-item-group
          v-model="selectedItems"
          multiple
          active-class=""
        >
          <template v-for="(item, index) in invoices">
            <v-list-item :key="'invoiceItem' + index" :value="item">
              <template v-slot:default="{ active }">
                <v-list-item-icon>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-icon>
                <v-list-item-content @click="rowClick(item.id, item.invoiceNumber)">
                  <v-tooltip>
                    <template v-slot:activator="{ on }">
                      <a v-on="on" @click.stop="" >#{{item.invoiceNumber}}</a>
                    </template>
                    <span>{{item.name}}</span>
                  </v-tooltip>
                  L/N: {{!item.loadNumber ? 'N/A' : item.loadNumber}}<br/>
                  {{item.creatorName}}<br/>
                  <v-list-item-subtitle>
                    <a @click.stop="$root.onShowLoadPreview(item.load_id)">#{{item.load_id}}</a>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{item.brokerName}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="text-right">
                  {{item.createdDatePST.substring(0,10)}}<br/>
                  <InvoiceStatusSnippet :item="item"></InvoiceStatusSnippet>

                  ${{item.parentTotal > 0 ? parseFloat(parseFloat(item.total-item.parentTotal).toFixed(2)).toLocaleString() : parseFloat(item.total.toFixed(2)).toLocaleString()}}
                  <template v-if="item.scheduleNumber > 0">#{{item.scheduleNumber}}</template>
                  <template v-if="item.parentReceivedDate > 0">
                    <v-chip small v-if="item.total <= item.amountReceived + item.parentAmountReceived" class="text-no-wrap success" dense>${{parseFloat(item.amountReceived.toFixed(2)).toLocaleString()}}</v-chip>
                    <v-chip small v-else class="text-no-wrap error" dense success>${{parseFloat(item.parentAmountReceived.toFixed(2)).toLocaleString()}}(-${{parseFloat(item.total - item.amountReceived - item.parentAmountReceived).toLocaleString()}})</v-chip>
                  </template>
                  <template v-else-if="item.receivedDate > 0">
                    <v-chip small v-if="item.totalWithoutFees <= item.amountReceived" class="text-no-wrap success" dense>${{parseFloat(item.factReceived.toFixed(2)).toLocaleString()}}</v-chip>
                    <v-chip small v-else class="text-no-wrap error" dense success>${{parseFloat(item.factReceived.toFixed(2)).toLocaleString()}}(-${{parseFloat(item.total - item.amountReceived).toLocaleString()}})</v-chip>
                  </template>
                  <template v-else>
                    <v-chip small class="text-no-wrap warning" dense>
                      ${{parseFloat(item.expectToReceive.toFixed(2)).toLocaleString()}}
                    </v-chip>
                  </template>
                </v-list-item-action>
              </template>
            </v-list-item>
            <v-divider :key="'invoiceDivider' + index"/>
          </template>
        </v-list-item-group>
      </v-list>

      <v-data-table
        v-else
        :headers="headers"
        :items="invoices"
        :search="search"
        :items-per-page="100"
        :footer-props="footer_props"
        v-model="selectedItems"
        height="calc(100vh - 200px)"
        fixed-header
        show-select
        @item-selected="onItemSelected"
        @toggle-select-all="onItemSelected"
        @click:row="rowClick($event.id, $event.invoiceNumber)"
      >

        <template v-slot:item.created="{ item }">
          <v-layout v-if="item.userCreated">
            <v-flex>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-avatar v-on="on"
                            @click.stop="$root.onShowUserPreview(item.userCreated, item.creatorName)"
                            style="cursor: pointer;"
                            class="ml-1"
                            :size="32"
                            :color="(item.creatorInitials && !item.creatorAvatar)?'#015aaa':null">
                    <v-img :src="$root.getImageUrl('avatar', item.creatorAvatar)" v-if="item.creatorAvatar"></v-img>
                    <span class="white--text" v-else-if="item.creatorInitials">{{item.creatorInitials}}</span>
                    <v-icon large v-else>account_circle</v-icon>
                  </v-avatar>
                </template>
                <span>{{item.creatorName}}</span>
              </v-tooltip>
            </v-flex>
            <v-flex>
              <template v-if="item.createdDatePST">
                {{item.createdDatePST.substring(0,10)}}
                <br/>
                {{item.createdDatePST.substring(11)}}
              </template>
            </v-flex>
          </v-layout>
        </template>

        <template v-slot:item.sentDate="{ item }">
          <v-layout v-if="item.userSended">
            <v-flex>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-avatar v-on="on"
                            @click.stop="$root.onShowUserPreview(item.userSended, item.senderName)"
                            style="cursor: pointer;"
                            class="ml-1"
                            :size="32"
                            :color="(item.senderInitials && !item.senderAvatar)?'#015aaa':null">
                    <v-img :src="$root.getImageUrl('avatar', item.senderAvatar)" v-if="item.senderAvatar"></v-img>
                    <span class="white--text" v-else-if="item.senderInitials">{{item.senderInitials}}</span>
                    <v-icon large v-else>account_circle</v-icon>
                  </v-avatar>
                </template>
                <span>{{item.senderName}}</span>
              </v-tooltip>
            </v-flex>
            <v-flex>
              <template v-if="item.sentDatePST">
                {{item.sentDatePST.substring(0,10)}}
                <br/>
                {{item.sentDatePST.substring(11)}}
              </template>
            </v-flex>
          </v-layout>
        </template>

        <template v-slot:item.broker="{ item }">
          <template v-if="item.broker">
            <div class="text-no-wrap">{{item.brokerName}}</div>
            <div class="text-no-wrap">{{item.terms}}</div>
          </template>
        </template>

        <template v-slot:item.invoiceNumber="{ item }">
          <div v-if="item.invoiceNumber" class="text-no-wrap">
            {{$t('Invoice')}}: <a href="#" @click.stop="$router.push('/invoices/page/'+item.id)">#{{item.invoiceNumber}}</a>
          </div>
          <div v-if="item.loadId" class="text-no-wrap">
            {{$t('Load')}}: <a href="#" @click.stop="$root.onShowLoadPreview(item.loadId)">#{{item.loadId}}</a>
          </div>
        </template>

        <!--<template v-slot:item.dueDate="{ item }">
          {{item.dueDate ? item.dueDate.split('T')[0] : ''}}
        </template>
        <template v-slot:item.created="{ item }">
          {{item.dueDate ? item.created.split('T')[0] : ''}}
        </template>-->
        <!--<template v-slot:item.sentDate="{ item }">
          {{$root.formatDate(item.sentDatePST.substring(0,10))}}
          <br/>
          {{item.sentDatePST.substring(11,19)}}
        </template>-->
        <template v-slot:item.loadUIDAndNumber="{ item }">
          <div class="text-no-wrap">
            Load Number: {{!item.loadNumber ? 'N/A' : item.loadNumber}}
          </div>
          <div class="text-no-wrap">
            <a href="#" @click.stop="$root.route('/users/page/'+item.dispatcherId)">{{item.dispatcherName}}</a>
          </div>
          <!--<div class="text-no-wrap">
            <a @click="$root.route('/loads/page/'+item.load_id)">{{item.loadUID}}</a>
            <v-tooltip bottom v-if="item.loadUID">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click.stop="$root.addNewPageTab('/loads/page/' + item.load_id)" v-if="$root.isLoadsViewAllowed">
                  <v-icon small class="mr-1">mdi-open-in-new</v-icon>
                </v-btn>
              </template>
              <span>{{$t('OpenExternal')}}</span>
            </v-tooltip>
          </div>-->
        </template>

        <template v-slot:item.trucks="{ item }">
          <template v-for="truck in item.trucksData">
            <v-layout :key="item.id +'_truck_' + truck.id">
              <a v-if="$root.isTrucksViewAllowed"
                 @click.stop="$root.route('/trucks/page/' + truck.id)">{{truck.name}}</a>
              <span v-else>{{truck.name}}</span>&nbsp;
            </v-layout>
            <!--</v-layout>-->
          </template>
        </template>
        <template v-slot:item.drivers="{ item }">
          <v-layout>
            <template v-for="driver in item.driversData">
              <v-flex :key="item.id +'_driver_' + driver.id">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-avatar v-on="on"
                              @click.stop="$root.onShowUserPreview(driver.id, driver.fullName)"
                              style="cursor: pointer;"
                              class="ml-1"
                              :size="24"
                              :color="(driver.initials && !driver.avatarUPLOAD) ? '#015aaa' : null">
                      <v-img :src="$root.getImageUrl('avatar', driver.avatarUPLOAD)" v-if="driver.avatarUPLOAD"></v-img>
                      <span style="color:#fff;" v-else-if="driver.initials">{{driver.initials}}</span>
                      <v-icon large v-else>account_circle</v-icon>
                    </v-avatar>
                  </template>
                  <span>{{driver.fullName}}</span>
                </v-tooltip>
              </v-flex>
            </template>
          </v-layout>
        </template>

        <template v-slot:item.status="{ item }">
          <InvoiceStatusSnippet :item="item"></InvoiceStatusSnippet>
        </template>

        <template v-slot:item.name="{ item }">
          <div style="min-width:200px;">{{item.name}}</div>
          <template v-if="item.updateNumber > 0">
            <div class="text-no-wrap">
              {{$t('Version')}} {{item.updateNumber}}
            </div>
          </template>
        </template>

        <template v-slot:item.factoring="{ item }">
          <span class="text-no-wrap" v-if="item.factoring >= 0">
            <!--{{item.factoring.toFixed(1)}}% + ${{parseFloat(item.factoringFee).toFixed(2)}} + ${{parseFloat(item.factoringScheduleFee).toFixed(2)}}
            &nbsp;<br/>&nbsp;-->
            ${{parseFloat(((item.amountReceived > 0 ? item.amountReceived : item.total) * (item.factoring / 100.0)) + parseFloat(item.factoringScheduleFee) + parseFloat(item.factoringFee)).toFixed(2)}}
          </span>
          <v-chip small v-else class="text-caption warning">{{$t('Invoices.BilledDirectly')}}</v-chip>
        </template>

        <template v-slot:item.total="{ item }">
          ${{item.total}}
          <template v-if="parseInt(item.loadFinished) === 2"><br/><v-chip color="warning" small>TONU</v-chip></template>
        </template>
        <template v-slot:item.amountReceived="{ item }">
            <template v-if="item.receivedDate > 0">
              <v-chip v-if="item.totalWithoutFees <= item.amountReceived" class="text-no-wrap success">${{item.factReceived.toLocaleString() }}</v-chip>
              <v-chip v-else class="text-no-wrap error" dense>${{item.factReceived.toLocaleString()}}(-${{item.total - item.amountReceived}})</v-chip>
            </template>
            <template v-else>
              <v-chip class="text-no-wrap warning" small>
                {{ $root.moneyValue(item.expectToReceive) }}
              </v-chip>
            </template>
        </template>

      </v-data-table>

      <!--<v-layout v-if="$root.isFullFinancialDataAllowedToView">
        <v-flex xs12 class="text-right">
          <v-btn class="ma-1" :disabled="selectedItems.length === 0" @click="createReportGroup(0, lastReportsGroupNumber + 1, $route.params.type, from, to)"><v-icon left>mdi-clipboard-check-outline</v-icon> {{$t('Reports.CreateReportsGroup')}}</v-btn>
        </v-flex>
      </v-layout>-->

    </v-card>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import InvoicesReportTemplate from './InvoicesReportTemplate.vue';
import ReportActions from './../../components/ReportActions.vue';
import InvoiceStatusSnippet from './../../components/InvoiceStatusSnipet.vue';
import InvoicesTotals from "./InvoicesTotals";
import invoicesMixin from "../../mixins/invoicesMixin";
import FiltersPanel from '../../components/FiltersPanel.vue';

export default {
  name: 'InvoicesReport',
  props: ['from', 'to', 'selectedStr', 'companyId'],
  components: {InvoicesTotals, InvoicesReportTemplate, ReportActions, InvoiceStatusSnippet, FiltersPanel },
  mixins: [reportsMixin],
  data: function () {
    return {
      loading: false,
      selectedItems: [],
      totalsCounts: {
        totalCount: 0,
        totalPaid: 0,
        totalAmount: 0,
        totalReceived: 0,
        totalReceivedAdv: 0,
        totalFactoring: 0,
        totalExpectedFactoring: 0,
        totalExpected: 0,
        totalDrivers: {},
        totalTrucks: {}
      },
      totalsCountsNames: {
        totalCount: 'Total'
      },
      filterStatus: 'All',
      filterDispatcher: 'All',
      filterDriver: 'All',
      filterTruck: 'All',
      filterBroker: 'All',
      statusFilter: {
        name: 'filterStatus',
        label: 'Status',
        field: '',
        list: [
          { id: 'All', name: 'All' },
          { id: 'New', name: 'New' },
          { id: 'Ready', name: 'Ready' },
          { id: 'Verified', name: 'Verified' },
          { id: 'Pending', name: 'Pending' },
          { id: 'Pending', name: 'Pending' },
          { id: 'Paid', name: 'Paid' },
          { id: 'Underpaid', name: 'Underpaid' },
          { id: 'Not Paid', name: 'Not Paid' },
          { id: 'Overdue', name: 'Overdue' }
        ],
        multiple: true
      },
      dispatcherFilter: {
          name: 'filterDispatcher',
          label: 'Dispatcher',
          field: '',
          multiple: true,
          list: [
          ]
      },
      driverFilter: {
        name: 'filterDriver',
        label: 'Driver',
        field: '',
        multiple: true,
        list: [
        ]
      },
      truckFilter: {
        name: 'filterTruck',
        label: 'Truck',
        field: '',
        multiple: true,
        list: [
        ]
      },
      brokerFilter: {
        name: 'filterBroker',
        label: 'Broker',
        field: '',
        multiple: true,
        list: [
        ]
      },
      invoices: [],
      search: '',
      reportsGroupsListKey: new Date().getTime(),
      headers: [
        { text: this.$root.t('Invoices.Number'), value: 'invoiceNumber' },
        { text: this.$root.t('Invoices.Status'), value: 'status' },
        { text: this.$root.t('Invoices.Creator'), value: 'created' },
        { text: this.$root.t('Invoices.Sender'), value: 'sentDate' },
        { text: this.$root.t('Invoices.Broker'), value: 'broker' },
        // { text: this.$root.t('Invoices.Created'), value: 'created' },
        // { text: this.$root.t('Invoices.name'), value: 'name' },
        { text: this.$root.t('Invoices.trucks'), value: 'trucks', sortable: false },
        { text: this.$root.t('Invoices.drivers'), value: 'drivers', sortable: false },
        { text: this.$root.t('Invoices.LoadUID'), value: 'loadUIDAndNumber' },
        { text: this.$root.t('Invoices.Factoring'), value: 'factoring' },
        { text: this.$root.t('Invoices.Amount'), value: 'total' },
        { text: this.$root.t('Invoices.Received'), value: 'amountReceived' }
      ],
      footer_props: {
        'items-per-page-options': [10, 25, 50, 100],
        'items-per-page-text': '',
        'disable-items-per-page': false
      }
    };
  },
  computed: {
  },
  mounted () {

    this.$root.setLastListPath(this.$route.path);

    // set saved user filter
    // if (this.$root.getLocalStorageItem('invoicesReportFilterStatus')) {
    //   this.statusFilter = this.$root.getLocalStorageItem('invoicesReportFilterStatus');
    // }

    this.$nextTick(() => {
      this.fetchData();
    });
  },
  methods: {
    clearTotals () {
      this.totalsCounts = {
        totalCount: 0,
        totalPaid: 0,
        totalAmount: 0,
        totalReceived: 0,
        totalReceivedAdv: 0,
        totalFactoring: 0,
        totalExpectedFactoring: 0,
        totalExpected: 0,
        totalDrivers: {},
        totalTrucks: {}
      };
    },
    // statusFilterChanged () {
    //   if (this.statusFilter !== 'All') {
    //     this.$root.setLocalStorageItem('invoicesReportFilterStatus', this.statusFilter);
    //   } else {
    //     this.$root.removeFromLocalStorageItem('invoicesReportFilterStatus');
    //   }
    //   this.fetchData();
    // },
    onItemSelected () {
      this.$nextTick(() => {
        let selected = [];
        for (let i = 0; i < this.selectedItems.length; i++) {
          selected.push(parseInt(this.selectedItems[i]['id']));
        }
        this.$emit('selected', selected);
      });
    },
    rowClick (id, number) {
      if (!id || id === 0) return;
      // this.$root.route('/invoices/page/' + id);
      this.$root.onShowInvoicePreview(id, number);
    },
    onFilterChanged (e) {
      let i = 0;
      let field = '';
      let value = '';
      const filtersFields = Object.keys(e);
      for (i = 0; i < filtersFields.length; i++) {
        field = filtersFields[i];
        value = Object.prototype.hasOwnProperty.call(e, field) ? e[field] : null;
        if (value !== '') {
          this[field] = Array.isArray(value) ? value.join(',') : value;
        }
      }
      if (this.isFilterInitialized) {
        this.fetchData();
      }
      this.isFilterInitialized = true;
    },
    fetchData (skipSelected = false, selected = []) {
      let i = 0;
      let invoice = {};
      let fees = 0;
      let factoringFees = 0;
      if (!this.from || !this.to) return;

      return new Promise((resolve, reject) => {
        this.loading = true;
        this.getInvoicesReportData(this.from, this.to, this.filterTruck, this.filterDriver, this.filterDispatcher, this.filterStatus, this.filterBroker).then((response) => {
          if (response.status === 'ok') {
            this.clearTotals();
            this.invoices = [];
            let selectedArray = [];
            if (!skipSelected && this.selectedStr) {
              selectedArray = this.selectedStr.split(',').map(v => {
                return parseInt(v);
              });
            }
            else if (!skipSelected && selected.length > 0) {
              for (let i = 0; i < selected.length; i++) {
                selectedArray.push(selected[i]);
              }
            }
            this.selectedItems = [];
            for (i = 0; i < response.invoices.length; i++) {
              invoice = response.invoices[i];
              invoice.totalWithoutFees = parseFloat(invoice.fees) > 0 ? (invoice.total - (invoice.total * (parseFloat(invoice.fees) / 100.0))) : invoice.total;

              if (selectedArray.length > 0 && selectedArray.indexOf(parseInt(invoice.id)) < 0) continue;

              this.totalsCounts.totalCount += 1;
              this.totalsCounts.totalDrivers = Object.assign(this.totalsCounts.totalDrivers, invoice.driversData);
              this.totalsCounts.totalTrucks = Object.assign(this.totalsCounts.totalTrucks, invoice.trucksData);

              fees = 0;
              if (parseFloat(invoice.fees) > 0) {
                fees = invoice.total * parseFloat(invoice.fees) / 100;
              } else {
                fees = parseFloat(invoice.factoringScheduleFee) + parseFloat(invoice.factoringFee);
              }
              factoringFees = parseFloat((invoice.amountReceived > 0 ? invoice.amountReceived : invoice.total) * (invoice.factoring / 100.0));
              if (parseInt(invoice.factoring) >= 0) {
                factoringFees += fees;
              }

              invoice.expectToReceive = parseFloat(invoice.expectToReceive);
              invoice.factReceived = parseFloat(invoice.factReceived);
              invoice.amountReceived = parseFloat(invoice.amountReceived);
              invoice.amountUnderpaid = parseFloat(invoice.amountUnderpaid);

              this.totalsCounts.totalPaid += parseFloat(invoice.amountReceived) > 0 ? 1 : 0;

              this.totalsCounts.totalAmount += parseFloat(invoice.total);
              this.totalsCounts.totalReceived += parseFloat(invoice.amountReceived - invoice.amountUnderpaid);
              this.totalsCounts.totalFactoring += parseFloat(invoice.amountReceived) > 0 ? parseFloat(factoringFees) : 0;
              this.totalsCounts.totalExpectedFactoring += parseFloat(invoice.amountReceived) > 0 ? 0 : parseFloat(factoringFees > 0 ? factoringFees : 0);
              this.totalsCounts.totalExpected += parseFloat(invoice.amountReceived) > 0 ? 0 : invoice.expectToReceive;
              this.totalsCounts.totalReceivedAdv += parseFloat(invoice.amountReceived) > 0 ? parseFloat(parseFloat(invoice.amountReceived - invoice.amountUnderpaid) - parseFloat(factoringFees)) : 0;

              invoice.loadUIDAndNumber = invoice.loadNumber + ' ' + invoice.loadUID;

              this.invoices.push(invoice);
            }
          }
          this.dispatcherFilter.list = [];
          for(let i = 0; i < response.dispatchers.length; i++) {
            this.dispatcherFilter.list.push({
              id: response.dispatchers[i].id,
              name: response.dispatchers[i].name
            })
          }
          this.driverFilter.list = [];
          for(let i = 0; i < response.drivers.length; i++) {
            this.driverFilter.list.push({
              id: response.drivers[i].id,
              name: response.drivers[i].name
            })
          }
          this.truckFilter.list = [];
          for(let i = 0; i < response.trucks.length; i++) {
            this.truckFilter.list.push({
              id: response.trucks[i].id,
              name: response.trucks[i].name
            })
          }
          this.brokerFilter.list = [];
          this.reportsGroupsListKey = 'reportsGroupsListKey' + new Date().getTime();
          this.onItemSelected();
          this.$forceUpdate();
          this.loading = false;
          resolve(this.totalsCounts);
        });
      });
    }
  }
};
</script>
